import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    let lang = "en";
    if (typeof window !== "undefined") {
      const savedLang = localStorage.getItem("bizu-lang");
      if (savedLang) {
        lang = savedLang;
      } else {
        const browserLanguage = navigator.language;
        if (browserLanguage && browserLanguage.startsWith("pt")) {
          lang = "pt";
        }
        localStorage.setItem("bizu-lang", lang);
      }
    }
    throw redirect({
      to: "/$lang",
      params: { lang },
    });
  },
});

